module.exports = __webpack_public_path__ + "img/wall-colors.980d799b.png";